import React, { useEffect, useState } from "react";
import { Button, Form, Row, Col } from "react-bootstrap";
import { fetchAllRoles } from "../../services/axios/apiManager";
import { format, parseISO } from "date-fns";
import { handleErrors, maskContactNumber } from "../../services/dataManager";
import { useNavigate, useParams } from "react-router-dom";
import { baseURL } from "../../services/axios/eps";
import { useFormik } from "formik";
import { basicFormValidations } from "./validations";
import LoadingSpinner from "../../Components/spinner";
import { getCities, getProvinces, haveToCheckEmail } from "./helpers";
const BasicInformation = ({
  formikRef,
  activeTab,
  handlePreviousTab,
  setImage,
  empData,
  cities = [],
  provinces = [],
  countries = [],
  setProvinces,
  setCities,
  submitEntireForm,
}) => {
  const navigate = useNavigate();
  const { id } = useParams();
  const [roles, setRoles] = useState([]);
  const [imageURL, setImageURL] = useState(null);
  const [loading, setLoding] = useState(false);

  const handleImageClick = () => {
    document.getElementById("imageUploadInput").click();
  };

  const handleImageChange = async (e) => {
    e.preventDefault();
    if (e?.target?.files && e.target.files[0]) {
      const file = e.target.files[0];
      setImage(file);
      const previewUrl = URL.createObjectURL(file);
      setImageURL(previewUrl);
    } else {
      setImage(null);
      setImageURL(null);
    }
  };

  useEffect(() => {
    const getRoles = async () => {
      const res = await fetchAllRoles();
      if (res?.data?.success && res?.data?.data) {
        setRoles(res.data.data);
      } else {
        handleErrors(res, navigate);
      }
    };
    getRoles();
  }, []);

  const formik = useFormik({
    initialValues: {
      first_name: empData?.first_name || "",
      last_name: empData?.last_name || "",
      email: empData?.email || "",
      password: empData?.password || "",
      role_id: empData?.role_id || "",
      status: empData?.status || 1,
      mobile_number: empData?.mobile_number || "",
      landline_number: empData?.landline_number || "",
      emergency_contact_name: empData?.emergency_contact_name || "",
      emergency_contact_number: empData?.emergency_contact_number || "",
      address_line_1: empData?.address_line_1 || "",
      address_line_2: empData?.address_line_2 || "",
      date_of_birth: empData?.date_of_birth || "",
      country_id: empData?.country_id || "",
      province_id: empData?.province_id || "",
      city_id: empData?.city_id || "",
    },
    validationSchema: basicFormValidations(id),
    onSubmit: async (values) => {
      try {
        setLoding(true);
        await submitEntireForm(values);
      } catch (error) {
        console.log("Error Upon form submition", error);
      } finally {
        setLoding(false);
      }
    },
  });
  useEffect(() => {
    formikRef.current.basicInfo = formik;
  }, [formik]);
  return (
    <Form onSubmit={formik.handleSubmit}>
      <Form.Group className="mb-3">
        {/* Image Upload Section */}
        <div className="text-center mb-4">
          <img
            crossorigin="anonymous"
            src={
              imageURL
                ? imageURL
                : empData?.image
                  ? `${baseURL}/uploads/file/${empData.image}`
                  : require("../../assets/images/t-one.png")
            }
            alt="Employee"
            className="img-fluid rounded center"
            style={{ maxHeight: "200px", objectFit: "contain" }}
            onClick={handleImageClick}
          />
          <input
            id="imageUploadInput"
            type="file"
            data-testid="image-upload"
            accept="image/*"
            onChange={handleImageChange}
            style={{ display: "none" }}
          />
        </div>
        <Row className="g-3">
          <Col md={6}>
            <Form.Label>First Name</Form.Label>
            <Form.Control
              type="text"
              data-testid="first-name"
              className="bg-dark text-light border-light input-placeholder-light"
              placeholder="Enter First Name"
              {...formik.getFieldProps("first_name")}
              isInvalid={
                formik.touched.first_name && !!formik.errors.first_name
              }
            />
            <Form.Control.Feedback type="invalid">
              {formik.errors.first_name}
            </Form.Control.Feedback>
          </Col>
          <Col md={6}>
            <Form.Label>Last Name</Form.Label>
            <Form.Control
              type="text"
              data-testid="last-name"
              className="bg-dark text-light border-light input-placeholder-light"
              placeholder="Enter Last Name"
              {...formik.getFieldProps("last_name")}
              isInvalid={formik.touched.last_name && !!formik.errors.last_name}
            />
            <Form.Control.Feedback type="invalid">
              {formik.errors.last_name}
            </Form.Control.Feedback>
          </Col>
        </Row>
        <Row className="g-3 mt-3">
          <Col md={id ? 6 : 4}>
            <Form.Label>Email</Form.Label>
            <Form.Control
              type="text"
              data-testid="email"
              className="bg-dark text-light border-light input-placeholder-light"
              placeholder="Enter email"
              {...formik.getFieldProps("email")}
              isInvalid={formik.touched.email && !!formik.errors.email}
            />
            <Form.Control.Feedback type="invalid">
              {formik.errors.email}
            </Form.Control.Feedback>
          </Col>
          {!id && (
            <Col md={4}>
              <Form.Label>Password</Form.Label>
              <Form.Control
                type="text"
                data-testid="password"
                className="bg-dark text-light border-light input-placeholder-light"
                placeholder="Enter password"
                {...formik.getFieldProps("password")}
                isInvalid={formik.touched.password && !!formik.errors.password}
              />
              <Form.Control.Feedback type="invalid">
                {formik.errors.password}
              </Form.Control.Feedback>
            </Col>
          )}
          <Col md={id ? 6 : 4}>
            <Form.Label>Role</Form.Label>
            <Form.Select
              type="text"
              data-testid="role"
              className="bg-dark text-light border-light input-placeholder-light"
              placeholder="Select Role"
              {...formik.getFieldProps("role_id")}
              isInvalid={formik.touched.role_id && !!formik.errors.role_id}
            >
              <option value="">Select Role</option>
              {roles?.map((c) => (
                <option key={c.id} value={c.id}>
                  {c.name}
                </option>
              ))}
            </Form.Select>
            <Form.Control.Feedback type="invalid">
              {formik.errors.role_id}
            </Form.Control.Feedback>
          </Col>
        </Row>
        <Row className="g-3 mt-3">
          <Col md={4}>
            <Form.Label>Date Of Birth</Form.Label>
            <Form.Control
              type="date"
              data-testid="dob"
              className="bg-dark text-light border-light input-placeholder-light"
              {...formik.getFieldProps("date_of_birth")}
              value={
                formik.values.date_of_birth
                  ? format(parseISO(formik.values.date_of_birth), "yyyy-MM-dd")
                  : ""
              }
              isInvalid={
                formik.touched.date_of_birth && !!formik.errors.date_of_birth
              }
            />
            <Form.Control.Feedback type="invalid">
              {formik.errors.date_of_birth}
            </Form.Control.Feedback>
          </Col>
          <Col md={4}>
            <Form.Label>Status</Form.Label>
            <Form.Select
              data-testid="status"
              className="bg-dark text-light border-light input-placeholder-light"
              {...formik.getFieldProps("status")}
              isInvalid={formik.touched.status && !!formik.errors.status}
            >
              <option value="1">Active</option>
              <option value="0">Inactive</option>
            </Form.Select>
            <Form.Control.Feedback type="invalid">
              {formik.errors.status}
            </Form.Control.Feedback>
          </Col>
          <Col md={4}>
            <Form.Label>Mobile Number</Form.Label>
            <Form.Control
              type="tel"
              data-testid="mobile"
              className="bg-dark text-light border-light input-placeholder-light"
              placeholder="Enter Mobile Number"
              {...formik.getFieldProps("mobile_number")}
              value={formik?.values?.mobile_number}
              onChange={(event) => {
                formik.setFieldValue("mobile_number", maskContactNumber(event));
              }}
              isInvalid={
                formik.touched.mobile_number && !!formik.errors.mobile_number
              }
            />

            <Form.Control.Feedback type="invalid">
              {formik.errors.mobile_number}
            </Form.Control.Feedback>
          </Col>
        </Row>

        <Row className="g-3 mt-3">
          <Col md={4}>
            <Form.Label>Landline Number</Form.Label>
            <Form.Control
              type="tel"
              className="bg-dark text-light border-light input-placeholder-light"
              placeholder="Enter Landline Number"
              {...formik.getFieldProps("landline_number")}
              value={formik?.values?.landline_number}
              onChange={(event) => {
                formik?.setFieldValue(
                  "landline_number",
                  maskContactNumber(event)
                );
              }}
              isInvalid={
                formik.touched.landline_number &&
                !!formik.errors.landline_number
              }
            />
            <Form.Control.Feedback type="invalid">
              {formik.errors.landline_number}
            </Form.Control.Feedback>
          </Col>
          <Col md={4}>
            <Form.Label>Emergency Contact Name</Form.Label>
            <Form.Control
              type="text"
              className="bg-dark text-light border-light input-placeholder-light"
              placeholder="Enter Emergency Contact Name"
              {...formik.getFieldProps("emergency_contact_name")}
              isInvalid={
                formik.touched.emergency_contact_name &&
                !!formik.errors.emergency_contact_name
              }
            />
            <Form.Control.Feedback type="invalid">
              {formik.errors.emergency_contact_name}
            </Form.Control.Feedback>
          </Col>
          <Col md={4}>
            <Form.Label>Emergency Contact Number</Form.Label>
            <Form.Control
              type="text"
              className="bg-dark text-light border-light input-placeholder-light"
              placeholder="Enter Emergency Contact Number"
              {...formik.getFieldProps("emergency_contact_number")}
              value={formik?.values?.emergency_contact_number}
              onChange={(event) => {
                formik?.setFieldValue(
                  "emergency_contact_number",
                  maskContactNumber(event)
                );
              }}
              isInvalid={
                formik.touched.emergency_contact_number &&
                !!formik.errors.emergency_contact_number
              }
            />
            <Form.Control.Feedback type="invalid">
              {formik.errors.emergency_contact_number}
            </Form.Control.Feedback>
          </Col>
        </Row>
        <Row className="g-3 mt-3">
          <Col md={6}>
            <Form.Label>Address Line 1</Form.Label>
            <Form.Control
              type="text"
              className="bg-dark text-light border-light input-placeholder-light"
              placeholder="Enter Address"
              name="address_line_1"
              {...formik.getFieldProps("address_line_1")}
            />
          </Col>
          <Col md={6}>
            <Form.Label>Address Line 2</Form.Label>
            <Form.Control
              type="text"
              className="bg-dark text-light border-light input-placeholder-light"
              placeholder="Enter Address"
              name="address_line_2"
              {...formik.getFieldProps("address_line_2")}
            />
          </Col>
        </Row>
        {/* Country Province abd city Fields */}
        <Row className="g-3 mt-3">
          <Col md={4}>
            <Form.Label>Country</Form.Label>
            <Form.Select
              className="bg-dark text-light border-light input-placeholder-light form-control"
              data-testid="country"
              {...formik.getFieldProps("country_id")}
              value={formik?.values?.country_id}
              onChange={async (event) => {
                formik.setFieldValue("country_id", event.target.value);
                formik.setFieldValue("province_id", "");
                formik.setFieldValue("city_id", "");
                await getProvinces(event.target.value, setProvinces, navigate);
              }}
              isInvalid={
                formik.touched.country_id && !!formik.errors.country_id
              }
            >
              <option value="">Select Country</option>
              <option key={"key-39"} value={39}>
                Canada
              </option>
              <option key={"key-233"} value={233}>
                United States
              </option>
              {countries?.map((c) => (
                <option key={c.id} value={c.id}>
                  {c.country_name}
                </option>
              ))}
            </Form.Select>
            <Form.Control.Feedback type="invalid">
              {formik.errors.country_id}
            </Form.Control.Feedback>
          </Col>
          <Col md={4}>
            <Form.Label>Province</Form.Label>
            <Form.Select
              className="bg-dark text-light border-light input-placeholder-light form-control"
              data-testid="province"
              {...formik.getFieldProps("province_id")}
              value={formik?.values?.province_id}
              onChange={async (event) => {
                formik?.setFieldValue("province_id", event.target.value);
                formik?.setFieldValue("city_id", "");
                await getCities(event.target.value, setCities, navigate);
              }}
              isInvalid={
                formik.touched.province_id && !!formik.errors.province_id
              }
            >
              <option disabled value="">
                Select Province
              </option>
              {provinces?.map((p) => (
                <option key={p.id} value={p.id}>
                  {p.province_name}
                </option>
              ))}
            </Form.Select>
            <Form.Control.Feedback type="invalid">
              {formik.errors.province_id}
            </Form.Control.Feedback>
          </Col>
          <Col md={4}>
            <Form.Label>City</Form.Label>
            <Form.Select
              className="bg-dark text-light border-light input-placeholder-light form-control"
              value={formik?.values?.city_id}
              {...formik.getFieldProps("city_id")}
              isInvalid={formik.touched.city_id && !!formik.errors.city_id}
            >
              <option disabled value="">
                Select City
              </option>
              {cities?.map((cty) => (
                <option key={cty.id} value={cty.id}>
                  {cty.city_name}
                </option>
              ))}
            </Form.Select>
            <Form.Control.Feedback type="invalid">
              {formik.errors.city_id}
            </Form.Control.Feedback>
          </Col>
        </Row>
        {/* Country Province abd city Fields Ends here*/}

        <div
          className="container-fluid mt-4 justify-content-between"
          data-testid="loading-spinner-lg"
        >
          <div className="d-flex justify-content-end">
            {loading && <LoadingSpinner size="lg" />}
            {activeTab !== "basicInfo" && (
              <Button
                variant="success"
                onClick={handlePreviousTab}
                className="mb-4 mr-2"
              >
                ← Previous
              </Button>
            )}
            <Button
              variant="danger"
              onClick={() => {
                navigate("/employees");
              }}
              className="mb-4 ml-2"
            >
              Exit
            </Button>
            <Button
              variant="success"
              onClick={() => {
                formik.handleSubmit();
              }}
              className="mb-4 ml-2"
            >
              Save Employee
            </Button>
          </div>
        </div>
      </Form.Group>
    </Form>
  );
};
export default BasicInformation;
